const rankings = [
  {
    rank: 1,
    title: '庆余年2',
    tag: '古装·权谋',
    hot: '🔥 980万',
    update: '更新至36集',
    trend: 'up',
  },
  {
    rank: 2,
    title: '封神第二部',
    tag: '奇幻·动作',
    hot: '🔥 865万',
    update: '高清完整版',
    trend: 'up',
  },
  {
    rank: 3,
    title: '流浪地球3',
    tag: '科幻·灾难',
    hot: '🔥 742万',
    update: '4K超清',
    trend: 'up',
  },
  {
    rank: 4,
    title: '歌手2026',
    tag: '音乐·综艺',
    hot: '🔥 658万',
    update: '更新至第10期',
    trend: 'new',
  },
  {
    rank: 5,
    title: '沙丘3',
    tag: '科幻·史诗',
    hot: '🔥 591万',
    update: '高清完整版',
    trend: 'up',
  },
];

const rankBadges: Record<number, string> = {
  1: 'bg-accent-500',
  2: 'bg-primary-500',
  3: 'bg-primary-600',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-950 dark-section">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-white mb-3">
            热播榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            实时热播排行，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 md:gap-6 py-4 md:py-5 border-b border-white/10 last:border-b-0 cursor-pointer hover:bg-white/5 -mx-3 px-3 rounded-lg transition-colors duration-150"
            >
              {/* Rank */}
              <div className="flex-shrink-0 w-10 md:w-12 text-center">
                <div
                  className={`w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center text-white font-heading font-bold text-sm md:text-base ${
                    rankBadges[item.rank] || 'bg-white/15'
                  }`}
                >
                  {item.rank}
                </div>
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="font-heading font-bold text-sm md:text-base text-white">
                    {item.title}
                  </h3>
                  <span className="text-[10px] text-white/30 bg-white/10 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.trend === 'new' && (
                    <span className="text-[10px] font-semibold bg-secondary-500 text-white px-2 py-0.5 rounded whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-4 text-[11px] md:text-xs text-foreground-500">
                  <span>{item.hot}</span>
                  <span className="text-foreground-600">{item.update}</span>
                </div>
              </div>

              {/* Arrow */}
              <div className="flex-shrink-0">
                <i className="ri-arrow-right-s-line text-white/30 group-hover:text-white/70 transition-colors text-lg"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <a
            href="#index"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium cursor-pointer"
          >
            查看更多排行
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}